export default [
  {
    path: '/order/list',
    name: '订单列表',
    component: (resolve) => require(['@/views/order/list/Index.vue'], resolve),
    meta: {
      pageId: 'order_list'
    }

  },
  {
    path: '/order/details',
    name: '订单详情',
    component: (resolve) => require(['@/views/order/details/Index.vue'], resolve),
    meta: {
      pageId: 'order_detail'
    }
  },

  {
    path: '/order/refund',
    name: '订单退款',
    component: (resolve) => require(['@/views/order/refund/index.vue'], resolve),
    meta: {
      pageId: 'order_refund'
    }
  },
  {
    path: '/order/record',
    name: '退款记录',
    component: (resolve) => require(['@/views/order/refund/mobile/components/RefundRecord.vue'], resolve),
    meta: {
      pageId: 'order_record'
    }
  },
  {
    path: '/order/success',
    name: '退款成功',
    component: (resolve) => require(['@/views/order/refund/success/index.vue'], resolve),
    meta: {
      pageId: 'order_refundSuccess'
    }
  },
  {
    path: '/order/sales',
    name: '售后订单',
    component: (resolve) => require(['@/views/order/sales/index.vue'], resolve),
    meta: {
      pageId: 'order_sales'
    }
  },
  {
    path: '/order/after-sales-order',
    name: '售后订单详情',
    component: (resolve) => require(['@/views/order/sales/details/index.vue'], resolve),
    meta: {
      pageId: 'order_salesDetail'
    }
  },
  {
    path: '/order/custom-samples',
    name: '大客户寄样订单',
    component: (resolve) => require(['@/views/order/custom/index.vue'], resolve),
    meta: {
      pageId: 'order_custom_samples'
    }
  },
  {
    path: '/order/custom-order',
    name: '大客户订单',
    component: (resolve) => require(['@/views/order/custom/custom-order/index.vue'], resolve),
    meta: {
      pageId: 'order_custom_order'
    }
  },
  {
    path: '/order/custom-fabric-library',
    name: '面料库',
    component: (resolve) => require(['@/views/order/custom/fabric-library/index.vue'], resolve),
    meta: {
      pageId: 'order_custom_fabricLibrary'
    }
  },
  {
    path: '/order/custom-printing',
    name: '印花',
    component: (resolve) => require(['@/views/order/custom/custom-printing/index.vue'], resolve),
    meta: {
      pageId: 'order_custom_printing'
    }
  },

  {
    path: '/billing', // 账期管理
    component: resolve => require(['@/views/billing/index.vue'], resolve),
    meta: {
      pageId: 'order_billing'
    }
  },

  {
    path: '/order/trackingInfo',
    name: '物流轨迹',
    component: (resolve) => require(['@/views/order/details/components/traningLineMt.vue'], resolve),
    meta: {
      pageId: 'order_trackingInfo'
    }
  },
  {
    path: '/order/cancelMT',
    name: '取消订单',
    component: (resolve) => require(['@/views/order/details/components/cancelMT.vue'], resolve),
    meta: {
      pageId: 'order_cancelMT'
    }
  }
]
